import React from 'react';

import styles from './AnimatedAudioIcon.module.scss';

const AnimatedAudioIcon = () => (
  <div className={styles.main}>
    <div className={styles.bar} />
    <div className={styles.bar} />
    <div className={styles.bar} />
    <div className={styles.bar} />
    <div className={styles.bar} />
  </div>
);

export default AnimatedAudioIcon;
